export const LOAD_USER = 'LOAD_USER';
export const USER_LOADED = 'USER_LOADED';
export const USER_LOGOUT = 'USER_LOGOUT';
export const ACCEPT_GDPR = 'ACCEPT_GDPR';
